import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import FormGroup from '../helpers/FormGroup'

class CompanyDetails extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const values = this.props.data
    const setData = this.props.setData

    return(
      <fieldset className="fieldset">
        <legend className="h2">Company Details</legend>
        <div className="row">
          <div className="col-12 col-sm-6">
            <FormGroup
              label="Your Name"
              value={values.filler_name}
              onChange={(v) => setData({filler_name: v})}
              errors={values.errors['filler_name']}
            />
          </div>
          <div className="col-12 col-sm-6">
            <FormGroup
              label="Your Email Address"
              value={values.email}
              onChange={(v) => setData({email: v})}
              errors={values.errors['email']}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <FormGroup
              label="Company Name"
              value={values.name}
              onChange={(v) => setData({name: v})}
              errors={values.errors['name']}
            />
          </div>
          <div className="col-12">
            <FormGroup label="Office Phone Number" value={values.office_phone} onChange={(v) => setData({office_phone: v})} />
          </div>
          <div className="col-12">
            <FormGroup label="Office Street Address" value={values.office_street_address} onChange={(v) => setData({office_street_address: v})} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6">
            <FormGroup label="City" value={values.office_city} onChange={(v) => setData({office_city: v})} />
          </div>
          <div className="col-12 col-sm-6">
            <FormGroup label="State" value={values.office_state} onChange={(v) => setData({office_state: v})} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6">
            <FormGroup label="Country" value={values.office_country} onChange={(v) => setData({office_country: v})} />
          </div>
          <div className="col-12 col-sm-6">
            <FormGroup label="Postal Code" value={values.office_postal_code} onChange={(v) => setData({office_postal_code: v})} />
          </div>
        </div>
      </fieldset>
    )
  }
}

export default CompanyDetails

